<template>
  <div class="basic-info-container el-row">
    <div class="info-con el-col" :class="rightNone?'el-col-22':'el-col-19'">
      <Detaillist
        :detaillist="infoConfig"
        :data="infoData"
      />
    </div>
    <template v-if="!rightNone">
      <!-- 插槽未生效时显示审核状态 -->
      <div class="condition-con el-col el-col-5" v-if="!rightSlot.slotIn && (infoData['auditState'] <=0 && showCondition)">
        <div class="condition-line">
          审核状态
        </div>
        <div class="condition-word" :class="['stateTopdiv', `color_${infoData['auditState']}`]">
          {{infoData['auditState'] == 0?'待提交':infoData['auditState'] == 1?'审核中':infoData['auditState'] == 2?'审核通过':'-'}}
            <span
            v-if="
              basicInfoData.auditLog != '' && infoData.auditState == 0
            "
          >
            <i class="el-icon-warning-outline" @click="warningblock"></i>
          </span>
        </div>
      </div>
      <div class="condition-con el-col el-col-5" v-else>
        <slot :name="rightSlot.slotName"></slot>
      </div>
    </template>

  </div>
</template>
<script>
import Detaillist from "@/components/detail/detaillist";
export default {
  name: 'basicInfoComponent',
  data() {
    return {
      condition: '',
      statePoint: '0'
    }
  },
  props: {
    // 为true时 右侧无内容
    rightNone: {
      type: Boolean,
      default: false
    },
    showCondition: {
      type: Boolean,
      default: true
    },    
    basicInfoData: {
      type: Object,
      default: ()=> {
        return {}
      }
    },
    // 左边部分数据配置
    infoConfig: {
      required: true,
      type:Object
    },
    // 左边部分数据
    infoData: {
      required: true,
      type: Object
    },
    /**
     * 2022/03/10  右边状态显示适配需求管理
     * rightSlot : {
     *  @param slotName 插槽名
     *  @param slotIn 是否开启插槽
     * }
     * 
     */
    rightSlot: {
      type: Object,
      default: ()=>{
        return {
          slotName: '',
          slotIn: false
        }
      }
    }
  },
  components: {
    Detaillist
  },
  methods: {
    warningblock() {
      this.$emit("warningblock");
    }
  }
}
</script>
<style lang="scss">
.basic-info-container{
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  margin-top: 6px;
  // margin-bottom: 20px;
  .el-col{
    margin-bottom: 4px !important;
  }
  .prop_div{
    color: #303133 !important;
    button{
      padding: 0px 14px !important;
      span{
        font-size: 14px !important;
      }
    } 
  }
  .condition-con{
    margin-top: 15px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    flex-wrap: wrap;
    .condition-line{
      width: 100%;
      text-align: right;
      color: #bbb9b9 !important;
      font-size: 14px;        
    }
    .condition-word{
      color: #666666;
      font-size: 20px !important;
    }
  }
  .stateTopdiv::before {
    content: "";
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    margin-right: 5px;
  }
  .color_0::before{
    background: #fec03d ;
  }
  .color_1::before{
    background: #409eff; ;
  }
  .color_2::before{
    background: #51d351 ;
  }
  .color_3::before{
    background: #51d351 ;
  }
  .warningblock {
    cursor: pointer;
    color: rgb(197, 192, 192);
  }
}
</style>